import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Flat markdown renderer (Sprint 5n). Used for memory bodies and text-file
 * previews. Styling lives in v3.css under `.kuvio-md` so the markup stays
 * clean and obeys the Console v3 design rules (two weights, no chrome).
 */
export function Markdown({ children }: { children: string }) {
  return (
    <div className="kuvio-md">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
    </div>
  );
}
